'use client'

import React from 'react';
import Grid from '@mui/material/Grid';
import { useTaskDetailStore } from '@/stores/TaskDetailStore';
import { useTaskStore } from '@/stores/TaskStore';
import { Tag } from '@/stores/TagsStore';
import { Task } from '../TaskManager';
import { TaskSubPanel } from './TaskSubPanel';

export interface TaskDetailDialogProps {
  open: boolean;
  onClose: () => void;
  task: Task;
  taskTags: Tag[];
}

function TaskDetailPanel() {
  const { taskId } = useTaskDetailStore();
  const { getTaskById, updateTask } = useTaskStore();

  const task = getTaskById(taskId || '');

  const handleUpdateTask = (taskId: string, updates: Partial<Task>) => {
    updateTask(taskId, updates);
  };

  return <>
    <Grid container spacing={2} sx={{
    }}>
      <Grid size={{ xs: 12, md: 18 }}>
        <TaskSubPanel task={task} onUpdateTask={handleUpdateTask} />
      </Grid>
    </Grid>
  </>;
};

export default TaskDetailPanel;
